import {BACKEND_URL} from '../config';
import {getCsrfToken} from '../services/fetcher';

export interface AuthInfo {
    enabled: boolean;
    authenticated: boolean;
    userId: string;
    firstName: string;
    lastName: string;
    preferredUsername: string;
}

class AuthService {
    private readonly authInfo: AuthInfo;

    constructor(authInfo: AuthInfo) {
        this.authInfo = authInfo;
    }

    isEnabled(): boolean {
        return this.authInfo.enabled;
    }

    isAuthenticated(): boolean {
        return this.authInfo.authenticated;
    }

    getUserId(): string {
        return this.authInfo.userId;
    }

    getFirstName(): string {
        return this.authInfo.firstName;
    }

    getLastName(): string {
        return this.authInfo.lastName;
    }

    async logout(): Promise<void> {
        const csrfToken = getCsrfToken();
        if (!csrfToken) {
            throw new Error('CSRF token is missing');
        }

        const response = await fetch((BACKEND_URL || '') + '/logout', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'X-XSRF-TOKEN': csrfToken,
            },
        });

        if (!response.ok) {
            throw new Error('Logout failed');
        }

        const body = await response.json();
        window.location.assign(body.logoutUrl);
    }

    login(): void {
        window.location.href = (BACKEND_URL || '') + '/oauth2/authorization/keycloak';
    }
}

export default AuthService;
